import { render, staticRenderFns } from "./ChatQuestions.vue?vue&type=template&id=8ed31792&"
import script from "./ChatQuestions.vue?vue&type=script&lang=js&"
export * from "./ChatQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports